import { render, staticRenderFns } from "./ManageOrganization.vue?vue&type=template&id=4d10cad2&"
import script from "./ManageOrganization.vue?vue&type=script&lang=js&"
export * from "./ManageOrganization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/advtool/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d10cad2')) {
      api.createRecord('4d10cad2', component.options)
    } else {
      api.reload('4d10cad2', component.options)
    }
    module.hot.accept("./ManageOrganization.vue?vue&type=template&id=4d10cad2&", function () {
      api.rerender('4d10cad2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/ManageOrganization.vue"
export default component.exports